import { Link } from "react-router-dom";
import PostCard from "@/components/base/PostCard";
import type { CommunityPost } from "@/mocks/community";

interface RelatedPostsProps {
  current: CommunityPost;
  allPosts: CommunityPost[];
}

export default function RelatedPosts({ current, allPosts }: RelatedPostsProps) {
  const sameCategory = allPosts.filter((p) => p.id !== current.id && p.category === current.category);
  const others = allPosts.filter((p) => p.id !== current.id && p.category !== current.category);
  const related = [...sameCategory, ...others].slice(0, 3);

  return (
    <section className="mt-12">
      <div className="mb-5 flex items-end justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
          <i className="ri-links-line text-secondary-500" aria-hidden="true" />
          相关推荐
        </h2>
        <Link
          to={`/topics?category=${current.category}`}
          className="text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          更多同类帖
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {related.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  );
}